import * as Actions from '../actionsgazeta';

const initialState = {};

const noticia = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_NOTICIA_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_NOTICIA_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default noticia;
